import React from "react";
import AssignmentIcon from "@mui/icons-material/Assignment";
import FormValidation from "../../../components/FormValidation/FormValidation";
import formFields from "../../../config/formFields.json";
import { useParams } from "react-router-dom";

const AddProjectMilestone = ({
  open,
  onClose,
  initialData = null,
  onSubmit,
  projects = [],
}) => {
  const isEdit = !!initialData?.milestone_id;
  const projectId=useParams()?.id;

  const initialValues = {
    project_id:
      initialData?.project_id?.toString() || projectId || null,
    milestone_code : initialData?.milestone_code?.toString() || null,
    milestone_name: initialData?.milestone_name?.toString() || null,
    milestone_description: initialData?.milestone_description?.toString() || null,
    milestone_start_date: initialData?.milestone_start_date || "",
    milestone_end_date: initialData?.milestone_end_date || "",
    is_active: initialData?.is_active ?? true,
    milestone_status_code : initialData?.milestone_status_code || 'PLANNED',
    milestone_min_date: initialData?.milestone_min_date || "today",
    milestone_max_date : initialData?.milestone_max_date || "today"
  };
  const getOptionsForField = (fieldName) => {
    switch (fieldName) {
      case "project_id":
        return projects.map((project) => ({
          value: project.project_id.toString(),
          label: project.project_name,
        }));
      default:
        return [];
    }
  };

  return (
    <FormValidation
      open={open}
      onClose={onClose}
      initialData={initialValues}
      onSubmit={onSubmit}
      formFields={formFields[projectId?"milestoneByProject":'projectMilestone'].basic.fields}
      title="Project Milestone"
      icon={AssignmentIcon}
      getOptionsForField={getOptionsForField}
      isEdit={isEdit}
      modelWidth={"55vw"}
      moduleName="projectMilestone"
    />
  );
};

export default AddProjectMilestone;
